import axios from "../axios-instance";
import {
  MyChangePassword_START,
  MyChangePassword_ERROR,
  IsDataSubmitedSuccessfullyChangePassword,
} from "../constants/myChangePassword";

export const updateMyChangePassword = (changePassword) => (dispatch) => {
  dispatch({
    type: MyChangePassword_START,
  });
  axios
    .post("user/change-pasword", changePassword)
    .then((res) => {
      dispatch({
        type: IsDataSubmitedSuccessfullyChangePassword,
        IsDataSubmitedSuccessfullyChangePassword: true,
      });
    })
    .catch((err) => {
      const message =
        err.response?.data?.message ||
        err.response?.data?.error ||
        (typeof err.response?.data?.data === "string"
          ? err.response.data.data
          : null) ||
        "Unable to change password. Please try again.";

      dispatch({
        type: MyChangePassword_ERROR,
        payload: { message },
      });
    });
};
